"use client";

import React from "react";
import { WheelSpinIcon } from "@/components/icons";
import { Button } from "@/components/ui/button";

interface WheelSpinButtonsProps {
  tickets: number;
  isSpinning: boolean;
  isDisabled: boolean;
  onSpin: (count: number) => void;
}

const SPIN_BIG_COUNT = 5;

/**
 * Spin buttons for 1x and 5x spins
 */
export const WheelSpinButtons: React.FC<WheelSpinButtonsProps> = ({ tickets, isSpinning, isDisabled, onSpin }) => {
  const handleSpin = (count: number) => {
    if (isSpinning) return;
    onSpin(count);
  };

  return (
    <div className="flex flex-col gap-2 w-[180px]">
      {/* Spin 1x Button */}
      <Button
        onClick={() => handleSpin(1)}
        disabled={isSpinning || isDisabled || tickets < 1}
        className="px-6 py-3 font-semibold whitespace-nowrap w-full text-base"
        rightIcon={<WheelSpinIcon width={20} height={20} fill="currentColor" />}
      >
        Spin
      </Button>

      {/* Spin 5x Button */}
      <Button
        onClick={() => handleSpin(SPIN_BIG_COUNT)}
        disabled={isSpinning || isDisabled || tickets < SPIN_BIG_COUNT}
        className="px-6 py-3 font-semibold whitespace-nowrap w-full text-base"
        variant="secondary"
        rightIcon={
          <div className="flex items-center gap-0.5">
            <WheelSpinIcon width={16} height={16} fill="currentColor" />
            <WheelSpinIcon width={16} height={16} fill="currentColor" />
            <WheelSpinIcon width={16} height={16} fill="currentColor" />
          </div>
        }
      >
        Spin {SPIN_BIG_COUNT}x
      </Button>
    </div>
  );
};
